webpackJsonp([0],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1736);

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(2340),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/index-8.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index-8.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75d43ea5", Component.options)
  } else {
    hotAPI.reload("data-v-75d43ea5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2340:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("faq")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/$t-is-not-defined.html"
    }
  }, [_vm._v("$t is not defined")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/can-vux-used-in-weapp.html"
    }
  }, [_vm._v("VUX 能否在微信小程序里使用")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/cannot-resolve-inline-desc.html"
    }
  }, [_vm._v("Can’t resolve ‘…/inline-desc’ in")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/difference-between-vux-template-and-webpack-template.html"
    }
  }, [_vm._v("vux2 和 Vue 官方 webpack 模板区别是什么？")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/document-framework.html"
    }
  }, [_vm._v("文档是用什么工具编写的？")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/does-vux-support-weex.html"
    }
  }, [_vm._v("Does VUX support weex")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/dupicate-style.html"
    }
  }, [_vm._v("样式冗余")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/is-vux-wechat-official-project.html"
    }
  }, [_vm._v("VUX 是否为微信团队项目")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/Uncaught-SyntaxError-Unexpected-token-export.html"
    }
  }, [_vm._v("Uncaught SyntaxError: Unexpected token export")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/vux-build-issue.html"
    }
  }, [_vm._v("VUX 打包体积过大")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/vux-server-render-support.html"
    }
  }, [_vm._v("VUX 服务端渲染")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/what-is-vux-virtual-component.html"
    }
  }, [_vm._v("什么是虚拟组件(virtual component)")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-cannot-i-import-all-components.html"
    }
  }, [_vm._v("为什么不能引入全部组件")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-cannot-i-use-vux-with-cdn.html"
    }
  }, [_vm._v("为什么不能直接引用 cdn 链接")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-close-my-issue.html"
    }
  }, [_vm._v("为什么作者直接关闭了我提的 issue")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-delete-my-issue-comment.html"
    }
  }, [_vm._v("为什么作者直接删除了我在 issue 下的评论")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-use-vue-file-for-distribution.html"
    }
  }, [_vm._v("为什么使用 .vue 源码分发而不是 js 文件")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/why-use-x-prefix-for-components.html"
    }
  }, [_vm._v("为什么部分组件要加"), _c('code', [_vm._v("x-")]), _vm._v("前缀")])], 1)]), _vm._v(" "), _c('li', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/en/faq/will-vux-stop-maintaining.html"
    }
  }, [_vm._v("担心停止维护")])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75d43ea5", module.exports)
  }
}

/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "faq | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 0.45c85260.js